export default class FileDrop {
    static setupField(dropArea, callback) {
        function preventDefault(e) {
            e.preventDefault();
            e.stopPropagation();
        }
        dropArea.addEventListener('dragover', (e) => preventDefault(e));
        dropArea.addEventListener('dragenter', (e) => {
            preventDefault(e);
            dropArea.classList.add('file-drop');
        });
        dropArea.addEventListener('dragleave', (e) => {
            preventDefault(e);
            dropArea.classList.remove('file-drop');
        });
        dropArea.addEventListener('drop', (e) => {
            preventDefault(e);
            dropArea.classList.remove('file-drop');
            // Get all files that are dropped
            let files = e.target.files || e.dataTransfer.files;
            let items = e.target.items || e.dataTransfer.items;
            getFilesWebkitDataTransferItems(items).then(file_list => {
                callback(file_list, files, items);
            });
            return false;
        });
        function getFilesWebkitDataTransferItems(dataTransferItems) {
            function traverseFileTreePromise(item, path = '') {
                return new Promise(resolve => {
                    if (item.isFile) {
                        item.file(file => {
                            file.filepath = path + file.name; //save full path
                            files.push(file);
                            resolve(file);
                        });
                    }
                    else if (item.isDirectory) {
                        let dirReader = item.createReader();
                        dirReader.readEntries(entries => {
                            let entriesPromises = [];
                            for (let entr of entries)
                                entriesPromises.push(traverseFileTreePromise(entr, path + item.name + "/"));
                            resolve(Promise.all(entriesPromises));
                        });
                    }
                });
            }
            let files = [];
            return new Promise((resolve, reject) => {
                let entriesPromises = [];
                for (let it of dataTransferItems)
                    entriesPromises.push(traverseFileTreePromise(it.webkitGetAsEntry()));
                Promise.all(entriesPromises)
                    .then(entries => {
                    resolve(files);
                });
            });
        }
    }
}
